import React from 'react';
import { useRadioContext } from '../../../context';
import styles from './RadioInput.module.scss';

export const RadioInput = (props: {
    reason: string;
    children: React.ReactNode;
    containerClassNames?: string;
}) => {
    const { reason, children, containerClassNames } = props;
    const { selection } = useRadioContext();

    return (
        <div className={containerClassNames}>
            <input
                type="radio"
                id={reason}
                data-testid={`${reason}-input`}
                value={reason}
                name="reason"
                defaultChecked={selection === reason}
                className={styles.radioInput}
            />
            <label htmlFor={reason}>{children}</label>
        </div>
    );
};
